<template>
    <div>
        <!-- ======= Featured Services Section Section ======= -->
        <section id="featured-services">
            <div class="container">
                <div class="row">
                    <div class="box" style="height: 5em">
                    </div>
                </div>
            </div>
        </section><!-- End Featured Services Section -->
        <!-- ======= Portfolio Section ======= -->
        <section id="about" class="section-bg">
            <div class="container" data-aos="fade-up">
                <header class="section-header">
                    <h3 class="section-title">Nos Références</h3>
                    <p>{{ reference.intro }}</p>
                </header>
                <div class="row portfolio-container" data-aos="fade-up" data-aos-delay="200">
                    <template v-for="(item,index) in reference.references">
                        <list-ref :item="item"></list-ref>
                    </template>
                </div>

                <!--<header class="section-header" style="margin-top: 6em">
                    <h3 class="section-title">Ce qu’ils en pensent</h3>
                </header>
                <div class="row about-cols">
                    <template v-for="item in reference.references">
                        <div v-if="item.isImage" class="col-md-4" data-aos="fade-up" :data-aos-delay="item.delay">
                            <div class="about-col">
                                <div class="img">
                                    <img :src="item.image" alt=""
                                         class="img-fluid-service">

                                </div>
                                <h2 class="title"><a href="#">{{ item.title }}</a></h2>
                                <p>
                                    {{ item.detail }}
                                </p>
                            </div>
                        </div>
                    </template>
                </div>-->
<!--                <div class="row portfolio-container"-->
<!--                     data-aos="fade-up"-->
<!--                     data-aos-delay="200">-->
<!--                    <template v-for="(item,index) in reference.references">-->
<!--                        <reference v-if="item.isImage" :item="item"/>-->
<!--                    </template>-->
<!--                </div>-->

            </div>
        </section><!-- End Portfolio Section -->
    </div>
</template>

<script>
    import Reference from "./components/Reference";
    import {mapActions, mapState} from 'vuex'
    import ListRef from "./components/ListRef";

    export default {
        name: "index",
        components: {ListRef, Reference},
        data(){
            return {

            }
        },
        computed:{
            ...mapState({
                reference: (state) => state.reference.reference
            })
        },
        created() {
            this.referenceAllAction()
        },
        methods:{
            ...mapActions('reference',['referenceAllAction'])
        }
    }
</script>

<style lang="scss" scoped>
    .portfolio-container{
        justify-content: center;
    }

    .img-fluid-service {
        width: 100%;
        height: 17em;
        /*margin: 0px 73px;*/
    }
</style>